import { PopupProvider } from '@salutejs/sdds-insol';
import '@salutejs/sdds-themes/css/sdds_insol__light.css';
import './globalStyles/styles.scss';
import './globalStyles/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'stories-react/dist/index.css';
import { QueryProvider } from './providers/QueryProvider';
import { RouterProvider } from './providers/RouterProvider';

const App = () => {
    return (
        <QueryProvider>
            <PopupProvider>
                <RouterProvider />
            </PopupProvider>
        </QueryProvider>
    );
};

export default App;
